// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xyKp","rootNoMargin":"styles_rootNoMargin__2RGqh"};